<template>
  <div>
    <form @submit.prevent="submit" :class="errorClass" >
      <span class="btn custom" @click="prevStep" v-if="this.step !== 1">Go back</span>

      <rp-nurse-lookup
        class="inner-form"
        v-if="lookupPatientStep"
        v-model="search"
        @submit="lookup"
        :userType="'nurse'" />

      <rp-nurse-form
        class="inner-form"
        v-if="nurseAddStep"
        @submit="submit"
        v-model="resource" />
    </form>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {email, required} from 'vuelidate/lib/validators'
  import {errorMessages} from '../../../api/error_messages'

  import form from '../../../mixins/form'

  import Button from '../../../components/ui/inputs/Button'
  import TextInput from '../../../components/ui/inputs/TextInput'
  import PatientForm from '../../../components/ui/forms/Patient'
  import UserLookup from '../../../components/ui/forms/UserLookup'
  import AddNurseForm from '../../../components/ui/forms/NurseShort'

  const LOOKUP_NURSE_STEP = 1
  const NURSE_ADD_STEP = 2

  export default {
    name: 'OperationMultiForm',
    mixins: [validationMixin, form],

    components: {
      'rp-button': Button,
      'rp-textinput': TextInput,
      'rp-nurse-form': AddNurseForm,
      'rp-nurse-lookup': UserLookup,
    },
    props: {
      nurse: {
        type: Boolean
      }
    },
    data() {
      return {
        step: 1,
        search: {
          email: ''
        }
      }
    },
    watch: { 
      nurse() {
        this.nurse ? this.loadAllNurses() : false
      }
    },
    mounted() {
      this.initStep()
    },

    computed: {
      ...errorMessages(['email']),

      lookupPatientStep() {
        return this.step === LOOKUP_NURSE_STEP
      },

      nurseAddStep() {
        return this.step === NURSE_ADD_STEP
      },

      isInvalid() {
        return this.$v.$invalid
      },

      nurseExists() {
        return !!this.resource.id
      }
    },
    validations: {
      resource: {
        email: {required, email}
      }
    },

    methods: {
      submit(val) {
        this.$v.$touch()
        this.$emit('submit', val)
        this.prevStep()
        this.search.email = ''
      },

      lookup(nurse) {
        this.$v.$touch()
        this.$emit('lookup', nurse)
      },

      initStep() {
        if(!this.nurseExists) {
          this.setStep(LOOKUP_NURSE_STEP)
        } else {
          this.setStep(NURSE_ADD_STEP)
        }
      },

      setStep(step) {
        this.step = step
      },

      prevStep() {
        if(this.step > 1) {
          this.step = this.step - 1
        }
      },

      loadAllNurses() {
        this.setStep(NURSE_ADD_STEP)
      }
    }
  }
</script>

<style lang="sass" scoped>
.btn.custom
  display: inline-flex
  margin-bottom: 1rem
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/AssociateNurse.vue